module.exports = __webpack_public_path__ + "c37e188e4610c71ad7bd88c88c7e349b.pdf";